import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/admin/login", { email, password });
      nav("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen pt-24 pb-24 bg-brand-bg flex items-center">
      <div className="max-w-md w-full mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="flex items-center gap-3 mb-6">
            <span className="h-10 w-10 flex items-center justify-center bg-primary-brand text-white">
              <Lock className="h-5 w-5" strokeWidth={2.5} />
            </span>
            <div>
              <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand">Admin Access</div>
              <h1 className="font-heading text-2xl font-black">Dispatcher Login</h1>
            </div>
          </div>
          <form onSubmit={submit} className="border border-slate-200 bg-white p-8">
            <label className="block">
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Email</div>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="w-full bg-transparent border border-slate-200 focus:border-primary-brand outline-none px-4 py-3 text-slate-900 text-sm"
              />
            </label>
            <label className="block mt-4">
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-2">Password</div>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full bg-transparent border border-slate-200 focus:border-primary-brand outline-none px-4 py-3 text-slate-900 text-sm"
              />
            </label>
            {err && (
              <div data-testid="admin-login-error" className="mt-4 border border-red-300 bg-red-50 text-red-700 px-3 py-2 text-xs">
                {err}
              </div>
            )}
            <button
              type="submit" disabled={loading}
              data-testid="admin-login-submit"
              className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-primary-brand hover:bg-[#E04F00] disabled:opacity-60 text-white px-6 py-3 font-bold uppercase tracking-wider text-sm"
            >
              {loading ? "Signing in…" : "Sign in"} <ArrowRight className="h-4 w-4" />
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
